module.exports = __webpack_public_path__ + "static/media/search-simple.590e6cee.gif";